import React, { useEffect } from 'react'
import { Form } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux';
import { appLoadDataAsyncThunk, renounceOwnershipLDBNAsyncThunk } from '../../redux/pagesSlices/emolume_bank';
import CustomButton from '../customs/CustomButton';

export default function RemoveOwnershipOfLDBN({ networkID, provider, address }) {

    const { analytics } = useSelector(state => state.bank);
    const { lemlOwner } = analytics;
    const dispatch = useDispatch();
    useEffect(() => {

        dispatch(appLoadDataAsyncThunk({ networkID, provider, address }))
        return () => {

        }
    }, [])


    return (
        <div className='method-component'>
            <h2>Remove Ownership from  LDBN</h2>
            <p>current owner {lemlOwner}</p>
            <p>After you call this method no one will be remains the owner of LDBN contract.</p>
            <Form noValidate>
                <div className='contact-form'>
                    <div className='contact-us '>
                        <div className='inner-row'>
                            <CustomButton
                                title={'Remove Ownership'}
                                type="submit"
                                slice={'bank'}
                                action={"renounceOwnershipLDBNAsyncThunk"}
                                variant="warning"
                                btnClass="buy-btn w-100"
                                onClick={(e) =>{
                                    e.preventDefault();
                                    dispatch(renounceOwnershipLDBNAsyncThunk({ networkID, provider }))
                                }
                            }
                            />
                        </div>

                    </div>
                </div>
            </Form>
        </div>
    )
}
